import React, { useState, useEffect } from "react";
import theme from "../../../Styles/theme";
import Modal from "react-modal";
import {
  Button,
  ChevronButton,
  Container,
  Conteudo,
  Footer,
  HelperImage,
  HelperSinalizadorDiv,
  Image,
  Title,
} from "./styles";
import { ModalDivX } from "../../ModalDivX";
import api from "../../../Services/api";
import { ModalLoader } from "../../ModalLoader";
import { Alert } from "../../Error/Alert";
import {
  ChevronLeft,
  ChevronRight,
  Circle,
  Edit2,
  Plus,
  Trash2,
} from "react-feather";
import { AddAnexo } from "./AddAnexo";
import { handleGetExtension } from "../../../Services/getExtentiomn";
import { base_url_api } from "../../../Utils/baseUrl";
import { RemoverAnexoModal } from "./RemoverAnexoModal";
import { EditarAnexoModal } from "./EditarAnexoModal";
import { FaFilePdf } from "react-icons/fa";
import { useFuncionarioPrefeitura } from "../../../Hooks/funcionarioPrefeitura";
import { usePrefeitura } from "../../../Hooks/usePrefeitura";
import { useFuncionarioCartorio } from "../../../Hooks/funcionarioCartorio";
import { useCartorio } from "../../../Hooks/cartorio";
import { isRural } from "../../../Utils/isRural";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,

    width: "60%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  open: boolean;
  onClose(): void;
  imovel_id: number;
  editavel: boolean;
  emAvaliacao: boolean;
  setCountAnexos:React.Dispatch<React.SetStateAction<number>>;
}

export interface IAnexos {
  IDENTIFICADOR: string;
  IMOVEL_ID: number;
  TITULO: string;
}
export function Anexos({
  open,
  onClose,
  imovel_id,
  editavel,
  emAvaliacao,
  setCountAnexos
}: Props) {
  const [anexos, setAnexos] = useState({} as IAnexos[]);
  const [anexoFocus, setAnexoFocus] = useState({} as IAnexos);
  const [indexAnexoFocus, setIndexAnexoFocus] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ message: "", title: "" });

  const [addAnexo, setAddAnexo] = useState(false);
  const [remAnexo, setRemAnexo] = useState(false);
  const [upAnexo, setUpAnexo] = useState(false);

  const { prefeituraIsLogged } = usePrefeitura();
  const { funcionarioPrefeituraIsLogged } = useFuncionarioPrefeitura();
  const { funcionarioCartorioIsLogged } = useFuncionarioCartorio();
  const { cartorioIsLogged } = useCartorio();

  function renderBolinhas() {
    if (anexos) {
      let cont = 0;
      setCountAnexos(anexos.length)
      if (anexos.length > 0) {
        return anexos.map((item) => {
          cont++;
          return (
            <span
              onClick={() => window.alert(cont)}
              style={{
                backgroundColor:
                  item.IDENTIFICADOR == anexoFocus.IDENTIFICADOR
                    ? theme.colors.primary
                    : theme.colors.darkGrey,
                width: "0.8vw",
                borderRadius: "0.8vw",
                color: "transparent",
                fontSize: "0.6vw",
              }}
            >
              _
            </span>
          );
        });
      }
    }
  }

  async function handleGetData() {
    try {
      setLoading(true);
      const { data } = await api.get(`/imovel-anexos${isRural() ? "-rural" : ""}/${imovel_id}`);
      setAnexos(data);
    } catch (error) {
      setError({
        title: "Ops",
        message:
          "Não foi possível caregar os anexos, tente novamente mais tarde!",
      });
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (imovel_id) handleGetData();
  }, [imovel_id]);

  useEffect(() => {
    if (anexos) {
      if (anexos.length > 0) {
        setAnexoFocus(anexos[0]);
      }
    }
  }, [anexos]);

  useEffect(() => {
    if (anexos[indexAnexoFocus]) setAnexoFocus(anexos[indexAnexoFocus]);
  }, [indexAnexoFocus]);

  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <ModalDivX execute={onClose} />
      <Container></Container>
      <ModalLoader loading={loading} />
      <Alert
        message={error.message}
        title={error.title}
        open={error.message.length > 0}
        onClose={() => setError({ message: "", title: "" })}
      />
      {!anexos.length ? (
        <>
          <Title>Este imóvel não possui nenhum anexo!</Title>
          <Footer>
            <Button
              onClick={() => {
                setAddAnexo(true);
              }}
            >
              {editavel &&
              (((cartorioIsLogged||funcionarioCartorioIsLogged) && !emAvaliacao) ||
                funcionarioPrefeituraIsLogged ||
                prefeituraIsLogged) ? (
                <Plus size="max(12px, 1.5vw)" />
              ) : (
                ""
              )}
            </Button>
          </Footer>
        </>
      ) : (
        <>
          <Title>{anexoFocus.TITULO}</Title>
          {anexoFocus.IDENTIFICADOR ? (
            <Conteudo>
              <ChevronButton
                disabled={anexos[0].IDENTIFICADOR == anexoFocus.IDENTIFICADOR}
                onClick={() => {
                  setIndexAnexoFocus(indexAnexoFocus - 1);
                }}
              >
                <ChevronLeft />
              </ChevronButton>
              {handleGetExtension(anexoFocus.IDENTIFICADOR.toLowerCase()) ==
              "pdf" ? (
                <FaFilePdf
                  size="max(18px, 2vw)"
                  color={theme.colors.dark}
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    window.open(
                      `${base_url_api}/anexos/${anexoFocus.IDENTIFICADOR}`
                    )
                  }
                />
              ) : (
                <HelperImage>
                  <Image
                    src={`${base_url_api}/anexos/${anexoFocus.IDENTIFICADOR}`}
                    onClick={() =>
                      window.open(
                        `${base_url_api}/anexos/${anexoFocus.IDENTIFICADOR}`
                      )
                    }
                  />
                </HelperImage>
              )}
              <ChevronButton
                disabled={
                  anexos[anexos.length - 1].IDENTIFICADOR ==
                  anexoFocus.IDENTIFICADOR
                }
                onClick={() => {
                  setIndexAnexoFocus(indexAnexoFocus + 1);
                }}
              >
                {" "}
                <ChevronRight />
              </ChevronButton>
            </Conteudo>
          ) : (
            ""
          )}
          <HelperSinalizadorDiv>{renderBolinhas()}</HelperSinalizadorDiv>
          {editavel &&
          (funcionarioCartorioIsLogged ||
            cartorioIsLogged ||
            funcionarioPrefeituraIsLogged ||
            prefeituraIsLogged) ? (
            <Footer>
              <Button onClick={() => setUpAnexo(true)}>
                <Edit2 size="max(12px, 1.5vw)" />
              </Button>
              <Button onClick={() => setAddAnexo(true)}>
                <Plus size="max(12px, 1.5vw)" />
              </Button>
              {prefeituraIsLogged || funcionarioPrefeituraIsLogged ? (
                ""
              ) : (
                <Button onClick={() => setRemAnexo(true)}>
                  <Trash2 size="max(12px, 1.5vw)" />
                </Button>
              )}
            </Footer>
          ) : (
            ""
          )}
        </>
      )}
      {editavel ||
      (funcionarioCartorioIsLogged && !emAvaliacao) ||
      funcionarioPrefeituraIsLogged ||
      prefeituraIsLogged ? (
        <>
          <AddAnexo
            open={addAnexo}
            onClose={() => setAddAnexo(false)}
            imovel_id={imovel_id}
            handleAddAnexo={(item: IAnexos) =>
              setAnexos((rest) => [...rest, item])
            }
          />
          <RemoverAnexoModal
            open={remAnexo}
            onClose={() => setRemAnexo(false)}
            anexo={anexoFocus}
            handleRemoveAnexo={() => {
              anexos.splice(indexAnexoFocus, 1);
              setAnexos(anexos);
              setIndexAnexoFocus(0);
            }}
          />

          <EditarAnexoModal
            open={upAnexo}
            onClose={() => setUpAnexo(false)}
            anexo={anexoFocus}
            handleUpdateAnexo={(title: string) => {
              anexos[indexAnexoFocus].TITULO = title;
              setAnexos(anexos);
            }}
          />
        </>
      ) : (
        ""
      )}
    </Modal>
  );
}
